import React, { Component } from 'react';
import './CheckoutContainer.scss';
import CheckoutList from '../CheckoutList/index';
import CheckoutTotal from '../CheckoutTotal/index';
import CheckoutConfirm from '../CheckoutConfirm/index';
import { ProductConsumer } from '../../../../Context';

class CheckoutContainer extends Component {
  render() {
    return (
      <section className='checkout' id='checkout'>
        <ProductConsumer>
          {value => {
            if (!value.confirmDisplayed) {
              return (
                <div>
                  <h2>Your Items</h2>
                  <div>
                    <CheckoutList value={value} />
                    <CheckoutTotal value={value} />
                  </div>
                  <div className='checkout__bottom-buttons'>
                    <button className='btn' onClick={value.showConfirm}>
                      Make Payment
                    </button>
                    <button className='btn' onClick={value.backToProducts}>
                      Back to Products
                    </button>
                  </div>
                </div>
              );
            } else {
              return <CheckoutConfirm value={value} />;
            }
          }}
        </ProductConsumer>
      </section>
    );
  }
}

export default CheckoutContainer;
